import request from '../request';

//上传图片
export const reqUploadData = (data) => request({ url:'/admin/upload', method:'post', data });
